import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { store } from '../redux/store';
import { ThemeProvider, CssBaseline } from '@mui/material';
import customTheme from '../styles/themes/customTheme';

interface ClientProviderProps {
  children: ReactNode;
}

export default function ClientProvider({ children }: ClientProviderProps) {
  return (
    <Provider store={store}>
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </Provider>
  );
}
